import img1 from '../../assets/kennedytheairflow_An_underground_cartoon_tunnel_system_sprawlin (1).png';
import React from 'react';
import { makeStyles } from '@mui/styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import { EffectCoverflow, Navigation } from 'swiper/modules';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

// Define styles using makeStyles
const useStyles = makeStyles({
  app: {
    paddingTop: '70px ',
  },
  body: {
    background: '#eee',
    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
    fontSize: '14px',
    color: '#000',
    margin: 0,
    padding: 0,
    height: '100%',
  },
  swiper: {
    width: '100%',
    paddingTop: '20px',
    paddingBottom: '50px',
    height: '100%',
    color: 'black',
  },
  swiperSlide: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    width: '300px',
    height: '300',
    '& img': {
      display: 'block',
      width: '100%',
    },
  },
});

export default function ResponsiveCarousel() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        padding: {
          lg: '8rem 2rem',
          md: '5rem 2rem',
          sm: '5rem 2rem',
          xs: '3rem 1rem',
        },
      }}
      className={classes.app}
    >
      <Box>
        <Box>
          <Typography
            sx={{
              color: ' #faf5ef',
              fontSize: { lg: '90px', md: '50px', sm: '50px', xs: '45px' },
              fontWeight: 400,
              lineHeight: {
                lg: '127.37px',
                md: '80.37px',
                sm: '50.37px',
                xs: '57.37px',
              },
              fontFamily: 'Chewy',
              textAlign: 'center',
            }}
          >
            The Boring Coin
          </Typography>{' '}
          <Box>
            <Typography
              sx={{
                color: ' #faf5ef',
                fontSize: { lg: '30px', md: '23px', sm: '27px', xs: '25px' },
                fontWeight: 400,
                lineHeight: {
                  lg: '70.37px',
                  md: '40.37px',
                  sm: '40.37px',
                  xs: '30.37px',
                },
                fontFamily: 'Chewy',
                textAlign: 'center',
              }}
            >
              A Memetic Analysis
            </Typography>{' '}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          height: {
            lg: '300px',
            md: '300px',
            sm: 300,
            xs: 300,
          },
        }}
      >
        <Swiper
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={false}
          navigation={true}
          loop={true}
          slidesPerView={`${matches ? 'auto' : '3'}`}
          style={{
            '--swiper-navigation-color': 'white', // Icon color
            '--swiper-navigation-size': '20px', // Icon size
            '--swiper-navigation-background': 'rgb(95, 58, 25)', // Background color
            '--swiper-navigation-opacity': '0.8', // Opacity
            '--swiper-navigation-border-radius': '50%', // Circular buttons
          }}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Navigation]}
          className={classes.swiper}
        >
          <SwiperSlide className={classes.swiperSlide}>
            <img src={img1} alt="ima" />
          </SwiperSlide>
          <SwiperSlide className={classes.swiperSlide}>
            <img src={img1} alt="ima" />
          </SwiperSlide>
          <SwiperSlide className={classes.swiperSlide}>
            <img src={img1} alt="ima" />
          </SwiperSlide>
          <SwiperSlide className={classes.swiperSlide}>
            <img src={img1} alt="ima" />
          </SwiperSlide>
          <SwiperSlide className={classes.swiperSlide}>
            <img src={img1} alt="ima" />
          </SwiperSlide>
          <SwiperSlide className={classes.swiperSlide}>
            <img src={img1} alt="ima" />
          </SwiperSlide>
          <SwiperSlide className={classes.swiperSlide}>
            <img src={img1} alt="ima" />
          </SwiperSlide>
          <SwiperSlide className={classes.swiperSlide}>
            <img src={img1} alt="ima" />
          </SwiperSlide>
          <SwiperSlide className={classes.swiperSlide}>
            <img src={img1} alt="ima" />
          </SwiperSlide>

          <style>
            {`
          .swiper-button-next, .swiper-button-prev {
            background-color: var(--swiper-navigation-background); /* Background */
            border-radius: var(--swiper-navigation-border-radius); /* Border radius */
            padding: 10px; /* Adjust button size */
            opacity: var(--swiper-navigation-opacity); /* Opacity */
            transition: opacity 0.3s ease; /* Smooth transition */
        
          }
          .swiper-button-next:hover, .swiper-button-prev:hover {
            opacity: var(--swiper-navigation-opacity); /* Keep opacity the same */
          }
          
        `}
          </style>
        </Swiper>
      </Box>
    </Box>
  );
}
